import { render, staticRenderFns } from "./CheckoutConfirmEmail.vue?vue&type=template&id=600b26d1"
import script from "./CheckoutConfirmEmail.vue?vue&type=script&lang=js"
export * from "./CheckoutConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./CheckoutConfirmEmail.vue?vue&type=style&index=0&id=600b26d1&prod&lang=scss"
import style1 from "./CheckoutConfirmEmail.vue?vue&type=style&index=1&id=600b26d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports